const state = () => ({
  // status visti
  // 0 : ยังไม่เข้าเยี่ยม || สีเทาเข้ม
  // 1 : กำลังเข้าเยี่ยม || สีส้ม
  // 2 : เข้าเยี่ยมแล้ว || สีเขียว
  // 3 : เข้าเยี่ยมไม่ตรงแผน || สีเหลือง
  // 4 : เลยแผน || สีเทาอ่อน
  // 5 : เข้าเยี่ยมนอกแผน || สีเหลืองวงกลม
  visitStatus: [
    {
      id: 0,
      message: 'ยังไม่เข้าเยี่ยม',
      backgroundColor: '#a4a8ac',
      textColor: '#656565',
      borderColor: '#a4a8ac'
    },
    {
      id: 1,
      message: 'กำลังเข้าเยี่ยม',
      backgroundColor: '#ffe8ca',
      textColor: '#fb8c00',
      borderColor: '#fb8c00'
    },
    {
      id: 2,
      message: 'เข้าเยี่ยมแล้ว',
      backgroundColor: '#e7ffd2',
      textColor: '#088546',
      borderColor: '#9bcb42'
    },
    {
      id: 3,
      message: 'เข้าเยี่ยมไม่ตรงแผน',
      backgroundColor: '#fff8be',
      textColor: '#bf9c00',
      borderColor: '#fdd835'
    },
    {
      id: 4,
      message: 'เลยแผน',
      backgroundColor: '#dcdad7',
      textColor: '#dcdad7',
      borderColor: '#dcdad7'
    },
    {
      id: 5,
      message: 'เข้าเยี่ยมนอกแผน',
      backgroundColor: '#e4941c',
      textColor: '#e4941c',
      borderColor: '#e4941c'
    }
  ]
})

export default {
  namespaced: true,
  state
}
